<template>
  <v-breadcrumbs :items="breadcrumbItems" class="rf-breadcrumbs">
    <template #divider>
      <v-icon>md:chevron_right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  props: ["pathName", "breadcrumbKey", "sequence"],
  computed: {
    baseUrl() {
      return `/apps/${this.$route.params.aid}`;
    },
    path() {
      return { id: this.$route.params.pid, name: this.pathName };
    },
    breadcrumbItems() {
      const base = [
        {
          title: "Dashboard",
          disabled: false,
          to: `${this.baseUrl}/dashboard`,
        },
      ];

      if (this.breadcrumbKey === "segment-create") {
        return [
          ...base,
          {
            title: "Segments",
            disabled: false,
            exact: true,
            to: `${this.baseUrl}/segments`,
          },
          {
            title: "Create new segment",
            disabled: true,
          },
        ];
      }

      if (this.breadcrumbKey === "retention-creative")
        return [
          ...base,
          ...this.getRetentionCreativeMiddleBreadcrumbs(),
          {
            title: this.path.name,
            disabled: false,
            exact: true,
            to: `${this.baseUrl}/retentions/${this.path.id}`,
          },
          {
            title: "Creative",
            disabled: true,
          },
        ];

      return base;
    },
  },
  methods: {
    getRetentionCreativeMiddleBreadcrumbs() {
      if (this.sequence.id)
        return [
          {
            title: "Guides",
            exact: true,
            disabled: false,
            to: `${this.baseUrl}/experiences`,
          },
          {
            title: this.sequence.name,
            exact: true,
            disabled: false,
            to: `${this.baseUrl}/experiences/${this.sequence.id}`,
          },
        ];

      return [
        {
          title: "Prompts",
          exact: true,
          disabled: false,
          to: `${this.baseUrl}/prompts`,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.rf-breadcrumbs {
  padding: 0px 0px 10px !important;
  :deep(li) {
    font-size: 13px;
    line-height: 19.5px !important;
    padding: 0 !important;
  }
  :deep(li:nth-child(even)) {
    padding: 0 8px !important;
  }
}
</style>
